// @ts-prune-ignore-next
export var SOLUTION_DID_NOT_HELP = function SOLUTION_DID_NOT_HELP(strictLocalize) {
  return {
    id: "SOLUTION_DID_NOT_HELP",
    label: strictLocalize({
      id: "MmVqUW",
      defaultMessage: [{
        "type": 0,
        "value": "Heeft niet geholpen het probleem op te lossen"
      }]
    })
  };
};
var SOLUTION_CONFUSING_OR_UNCLEAR = function SOLUTION_CONFUSING_OR_UNCLEAR(strictLocalize) {
  return {
    id: "SOLUTION_CONFUSING_OR_UNCLEAR",
    label: strictLocalize({
      id: "W2Gb+a",
      defaultMessage: [{
        "type": 0,
        "value": "Verwarrend of onduidelijk"
      }]
    })
  };
};
var SOLUTION_NOT_RELEVANT = function SOLUTION_NOT_RELEVANT(strictLocalize) {
  return {
    id: "SOLUTION_NOT_RELEVANT",
    label: strictLocalize({
      id: "p0ONzY",
      defaultMessage: [{
        "type": 0,
        "value": "Niet relevant"
      }]
    })
  };
};
export var OTHER_REASON = function OTHER_REASON(strictLocalize) {
  return {
    id: "OTHER_REASON",
    label: strictLocalize({
      id: "Udxlaw",
      defaultMessage: [{
        "type": 0,
        "value": "Anders"
      }]
    })
  };
};
export var CSAT_REASONS = function CSAT_REASONS(strictLocalize) {
  return [SOLUTION_DID_NOT_HELP(strictLocalize), SOLUTION_CONFUSING_OR_UNCLEAR(strictLocalize), SOLUTION_NOT_RELEVANT(strictLocalize), OTHER_REASON(strictLocalize)];
};